var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countdown"},[_c('div',{ref:"done",staticClass:"countdown__done",style:(_vm.doneStyle)},[_c('span',{class:{ 'right' : _vm.setTimePosition}},[_vm._v(_vm._s(_vm.timeLeft))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }